import PropTypes from 'prop-types';
import prepareTranslate from '@/helpers/dictionary';
import { ACCORD_TYPE } from '@/helpers/enums';
import SectionView from '../../SectionView';
import Modal from '../../DetailsModal';

const AlternativeFundViewForm = (props) => {
  const { opened, close, alternativeFund } = props;
  const t = prepareTranslate();

  const shouldShowValue = (val) => val !== undefined
        && val !== null
        && !(typeof val === 'number' && val === 0)
        && !(typeof val === 'string' && val.trim() === '0');

  const buildAlternativeFundDetails = (alternativeFundData) => {
    const accordTypeLabel = ACCORD_TYPE.find((a) => a.value === alternativeFundData.accordType)?.label || '';
    const commission = alternativeFundData.accordType === ACCORD_TYPE[0].value
      ? alternativeFundData.agentCommission
      : alternativeFundData.employeeAgentCommission;

    return [
      [
        {
          title: t('components.viewAgentAlternativeFunds.company'),
          value: alternativeFundData.companyId?.hebrew,
        },
        {
          title: t('components.viewAgentAlternativeFunds.branch'),
          value: alternativeFundData.branchId?.hebrew,
        },
        {
          title: t('components.viewAgentAlternativeFunds.alternativeFundNumber'),
          value: alternativeFundData.alternativeFundNumber,
        },
        {
          title: t('components.viewAgentAlternativeFunds.alternativeFundName'),
          value: alternativeFundData.alternativeFundName,
        },
      ].filter(Boolean),
      [
        {
          title: t('components.viewAgentAlternativeFunds.accordType'),
          value: accordTypeLabel,
        },
        {
          title: t('components.viewAgentAlternativeFunds.uid'),
          value: alternativeFundData.uid,
        },
        {
          title: t('components.viewAgentAlternativeFunds.alternativeFundType'),
          value: alternativeFundData.alternativeFundType,
        },
        shouldShowValue(commission) && {
          title: t('components.viewAgentAlternativeFunds.agentCommission'),
          value: commission,
        },
        shouldShowValue(alternativeFundData.comments) && {
          title: t('components.viewAgentAlternativeFunds.comments'),
          value: alternativeFundData.comments,
        },
      ].filter(Boolean),
    ];
  };

  if (!alternativeFund) return null;

  return (
        <Modal
            opened={opened}
            close={close}
            label={t('components.viewAgentAlternativeFunds.edit')}
        >
            {buildAlternativeFundDetails(alternativeFund).map((lines, idx) => (
                <SectionView key={idx} lines={lines} />
            ))}
        </Modal>
  );
};

AlternativeFundViewForm.propTypes = {
  opened: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  alternativeFund: PropTypes.object,
};

export default AlternativeFundViewForm;
